import useSWR from "swr"
import {API_ECP_PROJECTS} from "../constants/apiUrls"

export default function useEcpSummary(projectId) {
    const {data, mutate, error} = useSWR(`${API_ECP_PROJECTS}/${projectId}/summary`, {revalidateOnFocus: false})
    return {
        ecpSummary: data && data.summary,
        mutateEcpSummary: mutate,
        isLoadingEcpSummary: !error && !data,
        isErrorEcpSummary: error
    }
}